import callAPI from "../callApi";
import path from "../variables";
import { axios } from "@/services";

/**
 * Souscriptions (Admin entreprise + Root cross-tenant).
 * Backend S5 : SubscriptionController.
 *
 * Le wizard côté UI peut sauver l'état après chaque étape via draft()
 * (idempotent — un seul draft actif par entreprise, mis à jour en place).
 * submit() fige les totaux et passe le contrat en status "proposed".
 */
const subscriptions = {
	// Root only — liste tous les contrats (UI Root S6).
	listAll: (filter?: string) =>
		callAPI(
			"GET",
			`${path.base}/administration/contracts${filter ?? ""}`,
			"",
			"listing all contracts",
			{ skipCache: true },
		),

	me: (enterpriseUuid?: string) =>
		callAPI(
			"GET",
			`${path.base}/subscriptions/me${enterpriseUuid ? "?enterprise=" + encodeURIComponent(enterpriseUuid) : ""}`,
			"",
			"fetching subscription status",
			{ skipCache: true },
		),

	draft: (data: any) =>
		callAPI(
			"POST",
			`${path.base}/subscriptions/draft`,
			data,
			"saving subscription draft",
		),

	submit: (data: any = {}) =>
		callAPI(
			"POST",
			`${path.base}/subscriptions/submit`,
			data,
			"submitting subscription draft",
		),

	sign: (contractUuid: string, data: any = {}) =>
		callAPI(
			"POST",
			`${path.base}/subscriptions/${contractUuid}/sign`,
			data,
			"signing subscription contract",
		),

	activate: (contractUuid: string, data: any = {}) =>
		callAPI(
			"POST",
			`${path.base}/subscriptions/${contractUuid}/activate`,
			data,
			"activating subscription contract",
		),

	createTrial: (data: { enterprise: string; duration_days: number; notes?: string }) =>
		callAPI(
			"POST",
			`${path.base}/subscriptions/trial`,
			data,
			"creating trial period",
		),

	// PDF du contrat (S7). On NE PEUT PAS faire window.open(url) :
	// l'auth Bearer n'est pas portée par les nouveaux onglets, le
	// backend rejetterait en 401. À la place, fetch en blob via
	// l'instance axios authentifiée, puis déclenche le download.
	downloadContractPdf: async (contractUuid: string, filename?: string): Promise<void> => {
		const response = await axios.get(
			`${path.base}/subscriptions/${contractUuid}/pdf`,
			{ responseType: "blob" },
		);
		const blob = new Blob([response.data], { type: "application/pdf" });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = filename || `contrat-${contractUuid}.pdf`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		// Libère l'URL blob après un tick pour laisser le browser
		// initier le download avant la révocation.
		setTimeout(() => window.URL.revokeObjectURL(url), 1000);
	},

	listInvoices: (filter?: string) =>
		callAPI(
			"GET",
			`${path.base}/subscriptions/invoices${filter ?? ""}`,
			"",
			"listing invoices",
			{ skipCache: true },
		),

	generateInvoices: (period?: string) =>
		callAPI(
			"POST",
			`${path.base}/subscriptions/invoices/generate${period ? "?period=" + encodeURIComponent(period) : ""}`,
			{},
			"generating invoices",
		),

	// Avenant (S8) : crée un nouveau draft pré-rempli avec les lignes
	// du contrat actif. Le client repasse ensuite dans le wizard
	// classique pour modifier sa sélection.
	amend: () =>
		callAPI(
			"POST",
			`${path.base}/subscriptions/amend`,
			{},
			"creating amendment draft",
		),
};

export default subscriptions;
